<template>
  <div class="container">
    <div class="title">
      <img src="../../src/assets/images/memberInfo/logo.png" alt="" />
    </div>
        <div class="headerBac"></div>
    <div class="contentBox grjjbox">
      <div class="left">
        <img :src="obj.illustration" alt="" />
      </div>
      <div class="right">
        <div class="right-top">发布时间：{{obj.showTime}} 阅读量：{{obj.readCount}}</div>
        <div class="right-bottom">
          <div class="r-left">
            <div class="r-left-left">
              <div class="r-left-left-top">{{obj.fName}}</div>
              <div class="r-left-left-bottom">
                <img src="../../src/assets/images/xz.png" alt="" />
              </div>
            </div>
            <div class="r-left-right">
              <div class="r-left-right-top">personal profile</div>
              <div class="r-left-right-bottom">{{obj.personInfo?obj.personInfo.job: ''}}</div>
            </div>
          </div>
          <div class="r-right">
            <div class="r-right-content" v-html="obj.details">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footBac"></div>

  </div>
</template>
<script>
import API from '../../apis/index'

export default {
  name: "MemberDetail",
  components: {
    // CarouselCopy,
  },
  data() {
    return {
      params: {},
      obj: {}
    };
  },
  mounted() {
    const currentRouter = {
      name: '成员详情',
      path: '/memberDetail'
    }

    localStorage.setItem('currentRouter', JSON.stringify(currentRouter));
  },
  created() {
    this.params = JSON.parse(this.$route.query.item)
    this.init()
  },
  methods: {
    init() {
      this.$http.get(`${API.getForum}?type=2&fId=${this.params.fId}`).then(res => {
        console.log(res.data.data)
        this.obj = res.data.data
        
      })
    }
  }
};
</script>
<style scoped>
.container {
  width: 1000px;
  padding: 0 0 90px;
}

.headerBac{
    width: 100%;
    height: 60px;
    background: url("../../src/assets/images/headerBac.png") no-repeat;
    background-size: 100% 100%;
    margin-top: 20px;

}
.footBac{
    width: 100%;
    height: 60px;
    background: url("../../src/assets/images/footBac.png") no-repeat;
    background-size: 100% 100%;

}
.contentBox {
    width: 100%;
    /* height: 1098px; */
    background: url("../../src/assets/images/bodyBac.png") no-repeat;
    background-size: 100% 100%;
}

.grjjbox {
  display: flex;
  padding: 21px 46px 21px 21px;
}

.grjjbox .left {
  margin-right: 40px;
  align-self: baseline;
}

.grjjbox .right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex: 1;
  margin-top: 40px;
}

.grjjbox .right .right-top {
  font-size: 12px;
  font-family: PingFangTC-Regular, PingFangTC;
  font-weight: 400;
  color: #391603;
  line-height: 17px;
}

.grjjbox .right .right-bottom {
  display: flex;
  margin-top: 14px;
  align-self: flex-start;
}

.grjjbox .right .right-bottom .r-left {
  display: flex;
}

.grjjbox .right .right-bottom .r-left .r-left-left {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.grjjbox .right .right-bottom .r-left .r-left-left .r-left-left-top {
  display: flex;
  flex-direction: column;
  font-size: 22px;
  font-family: SourceHanSerifCN-Bold, SourceHanSerifCN;
  font-weight: bold;
  color: #391603;
  margin-bottom: 10px;
  margin-right: 10px;
  width: 20px;
}

.grjjbox .right .right-bottom .r-left .r-left-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.grjjbox .right .right-bottom .r-left .r-left-right .r-left-right-top {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  width: 10px;
  font-size: 7px;
  font-family: Helvetica-Bold, Helvetica;
  color: #391603;
  writing-mode: vertical-rl;
  margin-bottom: 5px;
}

.grjjbox .right .right-bottom .r-left .r-left-right .r-left-right-bottom {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  color: #391603;
  writing-mode: vertical-rl;
  margin-bottom: 5px;
  font-size: 14px;
  font-family: SourceHanSerifCN-Bold, SourceHanSerifCN;
  font-weight: bold;
  color: #7d6558;
}

.grjjbox .right .right-bottom .r-right {
  padding: 0 0 0 32px;
  border-left: 1px solid #eae0d5;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #553827;
  line-height: 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  /* justify-content: center; */
}

.grjjbox .right .right-bottom .r-right .r-right-content {
  text-align: justify;
}</style>